import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import {
  JobBoardElementTranslations,
  JobBoardElementTranslationsToken,
  JobBoardType,
  SettingsLink,
} from '@recruitee/http/types';

@Component({
  selector: 'rt-job-board-element',
  templateUrl: './job-board-element.component.html',
  styleUrls: ['./job-board-element.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobBoardElementComponent {
  public isPending: boolean = false;
  public readonly JobBoardType = JobBoardType;

  @Input() public name: string;
  @Input() public type: JobBoardType;
  @Input() public label: string;
  @Input() public logoUrl: string;
  @Input() public website: string;
  @Input() public isTrial: boolean;
  @Input() public posting: { status: string; url: string } | null;
  @Input() public canToggle: boolean;
  @Input() public tooltipMessage: string | null;
  @Input() public autoPostingDisabled: boolean;
  @Input() public settingsLink: SettingsLink | null;
  @Input() public pendingPosting: boolean;

  @Output() public postingAdd: EventEmitter<void> = new EventEmitter<void>();
  @Output() public openIntercom: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    @Inject(JobBoardElementTranslationsToken)
    public translations: JobBoardElementTranslations,
    private cdRef: ChangeDetectorRef,
  ) {}

  public get showPublish(): boolean {
    return (
      this.type === JobBoardType.Manual &&
      !this.autoPostingDisabled &&
      this.canToggle &&
      !this.pendingPosting &&
      !this.posting
    );
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.posting) {
      this.isPending = this.posting?.status === 'pending_review';
    }
  }

  public onAddPosting(): void {
    if (this.isPending) return;
    this.postingAdd.emit();
    this.cdRef.detectChanges();
  }
}
